import type { MessageStatus } from './types';

const TR_MONTHS = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];

/** +90 551 888 58 86 — gruplu, mono fontla kullanılır. */
export function formatPhone(e164: string): string {
  const m = /^\+90(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(e164);
  if (!m) return e164;
  return `+90 ${m[1]} ${m[2]} ${m[3]} ${m[4]}`;
}

/** +90 551 *** ** 86 — liste ve log satırlarında. */
export function maskPhone(e164: string): string {
  const m = /^\+90(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(e164);
  if (!m) return e164;
  return `+90 ${m[1]} *** ** ${m[4]}`;
}

function pad(n: number): string {
  return n < 10 ? '0' + n : String(n);
}

export function formatTime(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return `${d.getDate()} ${TR_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDateTime(iso: string): string {
  return `${formatDate(iso)} ${formatTime(iso)}`;
}

/** Gün ayırıcı: "Bugün", "Dün", "13 Kas 2026". */
export function formatDayLabel(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const startOf = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diffDays = Math.round((startOf(today) - startOf(d)) / 86_400_000);
  if (diffDays === 0) return 'Bugün';
  if (diffDays === 1) return 'Dün';
  return `${d.getDate()} ${TR_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** Liste için kısa göreli zaman: "2 dk", "1 sa", "dün", "3 gün". */
export function relativeTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.round(diff / 60_000);
  if (min < 1) return 'şimdi';
  if (min < 60) return `${min} dk`;
  const hour = Math.round(min / 60);
  if (hour < 24) return `${hour} sa`;
  const day = Math.round(hour / 24);
  if (day === 1) return 'dün';
  if (day < 7) return `${day} gün`;
  return formatDate(iso);
}

/** SLA sayacı: kalan süre. Negatifse gecikmiş. */
export function slaRemaining(iso: string): { text: string; late: boolean } {
  const diff = new Date(iso).getTime() - Date.now();
  const late = diff < 0;
  const abs = Math.abs(diff);
  const hour = Math.floor(abs / 3_600_000);
  const min = Math.round((abs % 3_600_000) / 60_000);
  const text = hour > 0 ? `${hour} sa ${min} dk` : `${min} dk`;
  return { text: late ? `${text} gecikti` : `${text} kaldı`, late };
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatMoney(value: string): string {
  return value;
}

/** Mesaj durumu → Türkçe etiket (ekran okuyucu ve tooltip için). */
export function statusLabel(status: MessageStatus | undefined): string {
  switch (status) {
    case 'queued':
      return 'Sırada';
    case 'sent':
      return 'Gönderildi';
    case 'delivered':
      return 'İletildi';
    case 'read':
      return 'Okundu';
    case 'failed':
      return 'Başarısız';
    case 'blocked':
      return 'Guard engelledi';
    default:
      return '';
  }
}

/** Arama için TR-duyarsız normalize (İ/ı sorunu). */
export function normalizeTr(value: string): string {
  return value.toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ').trim();
}

export function includesTr(haystack: string, needle: string): boolean {
  if (!needle) return true;
  return normalizeTr(haystack).includes(normalizeTr(needle));
}

export function classNames(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
